module.exports = __webpack_public_path__ + "static/media/logo_white.c427c629.svg";